import { rgba } from 'polished';
import { typographyToCss } from 'shared/lib/mui';
import styled from 'styled-components';

export const InputContainer = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(2)};

  padding: 0 ${({ theme }) => theme.spacing(4)} 0
    ${({ theme }) => theme.spacing(5)};
  width: 100%;

  height: 5.6rem;

  border-bottom: 1px solid ${({ theme }) => theme.palette.grey[400]};

  color: ${({ theme }) => rgba(theme.palette.text.primary, 0.45)};
`;

export const IconContainer = styled.span`
  display: flex;
  align-items: center;

  font-size: 1.6rem;
  line-height: 62.5%;
`;

export const Input = styled.input`
  ${({ theme }) => typographyToCss(theme.typography.subtitle1)};
  flex: 1;
  border: none;
  margin: 0;
  padding: 0;
  min-width: 0;

  outline: none;
  background: transparent;

  color: ${({ theme }) => theme.palette.text.primary};

  &::-webkit-input-placeholder {
    color: ${({ theme }) => rgba(theme.palette.text.primary, 0.3)};
  }

  &::-moz-placeholder {
    color: ${({ theme }) => rgba(theme.palette.text.primary, 0.3)};
  }

  &:-ms-input-placeholder {
    color: ${({ theme }) => rgba(theme.palette.text.primary, 0.3)};
  }
`;

export const ClearButton = styled.button`
  padding: 0;
  margin: 0;

  cursor: pointer;
  background: transparent;
  border: none;

  font-size: 1.6rem;
  line-height: 62.5%;
  color: inherit;
`;
